module.exports = __webpack_public_path__ + "assets/img/0.16688950.png";